import React from 'react';
import './DarkMode.css';
const DarkMode = () => {
    return (
        <div id="kwalys-switch">
            
        </div>
    );
};

export default DarkMode;